module.exports = __webpack_public_path__ + "static/img/introduce_4.cbc68df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_4.png
// module id = ko6S
// module chunks = 1